import { Easings } from "@/config/easings";
import { motion, transform, type Variants } from "framer-motion";
import { ShareConfig } from "./config";
import type { ReactNode } from "react";
import { polarToCartesian } from "@/utils/polar-to-cortesian";

type TProps = {
  idx: number;
  length: number;
  isActive: boolean;
  children: ReactNode;
};

const variants: Variants = {
  visible: ({ x, y }: ReturnType<typeof polarToCartesian>) => ({
    x,
    y,
    scale: 1,
  }),
  hidden: {
    x: 0,
    y: 0,
    scale: 0.75,
  },
};
const ShareProviderButton: React.FC<TProps> = (props) => {
  const angle = transform(
    props.idx,
    [0, props.length - 1],
    [ShareConfig.startAngle, ShareConfig.endAngle],
  );
  const point = polarToCartesian(angle, ShareConfig.outerRadius);
  return (
    <motion.div
      transition={{
        duration: 0.5,
        ease: Easings.one,
      }}
      custom={point}
      variants={variants}
    >
      {props.children}
    </motion.div>
  );
};
export default ShareProviderButton;
